import React from 'react';

import { StyledOcticon, Tooltip } from '@primer/react';
import { InfoIcon } from '@primer/octicons-react';

import classNames from 'classnames';

export const InfoTooltip = ({
  label = '',
  align = 'right',
  direction = 'ne',
  className = 'fill-white',
}) => (
  <Tooltip
    className="flex items-center"
    aria-label={label}
    align={align}
    direction={direction}
    wrap
  >
    <StyledOcticon
      className={classNames(className)}
      icon={InfoIcon}
      size="small"
    />
  </Tooltip>
)

export default InfoTooltip;
